module.exports = __webpack_public_path__ + "static/media/msg.1bd433f3.svg";